import React from "react";
import badgeStyles from "./styles/badges.module.css";

export function Stacks({ stacks = [] }) {
  return (
    stacks.length > 0 && (
      <div className={badgeStyles["project-stacks"]}>
        {stacks.map((stack) => (
          <div key={stack} className={badgeStyles["project-stack-badge"]}>
            {stack}
          </div>
        ))}
      </div>
    )
  );
}

export function Description({ item }) {
  return item.descriptions?.length ? (
    <ul>
      {item.descriptions.map((text) => (
        <li key={text}>{text}</li>
      ))}
    </ul>
  ) : (
    <>{item.description || item.summary}</>
  );
}
